// @ts-nocheck
import { useRef, useEffect, useState } from "react";
import PropTypes from "prop-types";
import SignatureCanvas from "react-signature-canvas";
import { Button, Box, Stack } from "@mui/material";
import { useDispatch } from "react-redux";
import { SignatureConsent } from "./SignatureModal";

export default function DrawSignaturePad({ setFields, addSignature }) {
  const canvasRef = useRef(null);
  const dispatch = useDispatch();
  const [isEmpty, setIsEmpty] = useState(true);
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    if (canvasRef.current) {
      setIsEmpty(canvasRef.current.isEmpty());
    }
  }, []);

  const handleClear = () => {
    canvasRef.current.clear();
    setIsEmpty(true);
  };

  const handleSave = () => {
    if (isEmpty) return;
    if (canvasRef.current.isEmpty()) return;

    const dataUrl = canvasRef.current.toDataURL("image/png");

    const newData = { type: "Signature", text: dataUrl };

    addSignature(newData, dispatch);

    setFields((prev) =>
      prev.map((group) => {
        if (group.type === "Signature") {
          return {
            ...group,
            list: [
              ...group.list.slice(0, -1),
              newData,
              group.list[group.list.length - 1],
            ],
          };
        }
        return group;
      }),
    );
  };

  return (
    <Box>
      <Box
        sx={{
          border: "1px solid #ccc",
          width: "100%",
          height: "200px",
          marginBottom: 2,
        }}
      >
        <SignatureCanvas
          penColor="black"
          canvasProps={{
            width: 500,
            height: 200,
            className: "sigCanvas",
            style: { backgroundColor: "white" },
          }}
          ref={canvasRef}
          onEnd={() => setIsEmpty(canvasRef.current.isEmpty())}
        />
      </Box>

      <SignatureConsent isChecked={isChecked} setIsChecked={setIsChecked} />

      <Stack
        direction="row"
        spacing={2}
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Button onClick={handleClear}>Clear</Button>
        <Button
          sx={{
            ...(isEmpty || !isChecked ? { cursor: "not-allowed" } : {}),
          }}
          className={`btnPink ${isEmpty || !isChecked ? "sow-btn-disabled" : ""}`}
          onClick={handleSave}
        >
          Save
        </Button>
      </Stack>
    </Box>
  );
}

DrawSignaturePad.propTypes = {
  setFields: PropTypes.func.isRequired,
  addSignature: PropTypes.func,
};